<template>

  <div>
    <div class="card cr-card" style="margin:0px 30px 30px 30px;">
      <div class="card-body">
        <h5 class="card-title">{{sectionTitle}}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{sectionSubtitle}}</h6>
        <div class="table-responsive-xxl">
          <table class="cr-resume-table table table-striped table-hover">
            <thead>
            <tr>
              <th class="cr-resume-background-none cr-resume-border-bottom-none cr-resume-border-right">&nbsp;</th>
              <th colspan="3" class="cr-resume-border-top cr-resume-border-right fs-5 text-center">As Captain</th>
              <th colspan="3" class="cr-resume-border-top cr-resume-border-right fs-5 text-center">As Crew</th>
              <th colspan="3" class="cr-resume-border-top cr-resume-border-right fs-5 text-center">Total</th>
            </tr>
            <tr>
              <th class="cr-resume-background-none cr-resume-border-top-none cr-resume-border-right">&nbsp;</th>
              <th class="text-center text-nowrap">Less than<br>8.5m (28 ft)</th>
              <th class="text-center text-nowrap">8.5m (28 ft)<br>- 12m (39 ft)</th>
              <th class="text-center text-nowrap cr-resume-border-right">Greater than<br>12m (39 ft)</th>
              <th class="text-center text-nowrap">Less than<br>8.5m (28 ft)</th>
              <th class="text-center text-nowrap">8.5m (28 ft)<br>- 12m (39 ft)</th>
              <th class="text-center text-nowrap cr-resume-border-right">Greater than<br>12m (39 ft)</th>
              <th class="text-center text-nowrap">Less than<br>8.5m (28 ft)</th>
              <th class="text-center text-nowrap">8.5m (28 ft)<br>- 12m (39 ft)</th>
              <th class="text-center text-nowrap cr-resume-border-right">Greater than<br>12m (39 ft)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-nowrap cr-resume-border-right">My Boat</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.self.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.self.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.self.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.self.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.self.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.self.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.self.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.self.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.self.large)"></td>
            </tr>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Friends Boat</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.friend.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.friend.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.friend.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.friend.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.friend.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.friend.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.friend.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.friend.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.friend.large)"></td>
            </tr>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Charter Boat</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.charterCompany.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.charterCompany.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.charterCompany.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.charterCompany.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.charterCompany.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.charterCompany.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.charterCompany.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.charterCompany.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.charterCompany.large)"></td>
            </tr>
            <tr>
              <td class="text-nowrap cr-resume-border-right">Commercial</td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.commercial.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.captain.commercial.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.captain.commercial.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.commercial.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.crew.commercial.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.crew.commercial.large)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.commercial.small)"></td>
              <td class="text-center" v-html="formatResumeDaysCell(sectionData.total.commercial.medium)"></td>
              <td class="text-center cr-resume-border-right" v-html="formatResumeDaysCell(sectionData.total.commercial.large)"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="cr-resume-footer-note">A | B% - this is logged days (at least four hours) experience with the percentage of entries that have been verified by either a crewmate on the vessel at the time or directly with the charter company via Charter Rode. The n-m below each logged experience represents how many entries have been verified by crewmate (n) or charter company (m) digital verification. Charter company verification is the highest trusted verification. Crewmate digital verification is considered to be very reliable. Self verification may need to be verified directly with the sailor.</div>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: 'ResumeSectionBoatOwnershipView',
  props: {
    'sectionTitle': String,
    'sectionSubtitle':  String,
    'sectionData': Object
  },
  methods: {
    formatResumeDaysCell(aCell) {
      if ( aCell.days > 0 ) {
        return '<div>'+aCell.days+'<span style="position:relative;top:-1px;font-size: 10px;color:#888;"> | '+aCell.verified.percent+'</span></div><div style="font-size: 10px;color:#888;">'+aCell.verified.crewmate+'-'+aCell.verified.charterCompany+'</div>'
      } else {
        return '--'
      }
    }
  }
}
</script>

<style>
.cr-resume-table {
  font-size:12px;
  width: 100%;
}

.cr-resume-table th {
  background: #f6f6f6;
}

.cr-resume-background-none {
  background: transparent!important;
}

.cr-resume-border-top {
  border-top: 1px solid #ccc;
}
.cr-resume-border-right {
  border-right: 1px solid #ccc;
}

.cr-resume-border-top-none {
  border-top:none!important;
}
.cr-resume-border-bottom-none {
  border-bottom:none!important;
}

.cr-resume-footer-note {
  font-size: 11px;
  color:#999;
}
</style>